import { Error } from '../interface/upplm.common.interface';
export class qvSummariesResponse {
    summary?: Summary;
    errors?: Error[];
}

export class AssignedClientKey {
    clientKey: string;
    placardIdList: Placardidlist[];
}

export class Summary {
    assignedClientKeys: AssignedClientKey[];
    startDate?: string;
    endDate?: string;
    clientKey: string;
    totalClientKeys?: Clientkey[];
}

export class Clientkey {
    clientKey: string;
    nickname: string;
    selected: boolean;
}

export class Placardidlist {
    placardId: string;
    placardStatus: string;
}

export class qvSummariesRequest {
    cookie: string;
    username: string;
    startDate: string;
    endDate: string;
}

export class valueStaticQvSummary {
    id: number;
    name: string;
    value: number;
}

export class filterObject {
    checkbox: string[];
    combo: valueStaticQvSummary;
}

export class cards {
    placardId: string;
    placardStatus: string;
    statusDescription?: string;
    clientKey?: string;
    description?: string;
}

export class cardsData {
    placardId: string;
    color: string;
    total: string;
    description: string;
    statusDescription: string;
}

export class Column {
    columnIndex: number;
    field: string;
    text: string;
    width: number;
    dataminwidth: number;
    resizeButtonLimit: number;
    allowSort: boolean;
    ascSort: boolean;
    descSort: boolean;
    resizeButtonActive: boolean;
}

export class QVCookie {
    name: string;
}